import { render, staticRenderFns } from "./ViewServiceCode.vue?vue&type=template&id=a363e580"
import script from "./ViewServiceCode.vue?vue&type=script&lang=js"
export * from "./ViewServiceCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports